import React, { Component } from 'react';
import { Toast, Tabs, WhiteSpace, List, Picker, Checkbox } from 'antd-mobile';
import { CommonlyHeadMembers } from '../../common/headnav';
import * as fun from '../../../components/common';
import * as services from '../../projects/services';
import { createBrowserHistory } from "history";
import './style.less';
import { Button } from 'antd';
const history = createBrowserHistory();
const tabs2 = [
    { title: '密码添加', sub: '1' },
    { title: '自动匹配', sub: '2' },
];
const CheckboxItem = Checkbox.CheckboxItem;
const posts = [
    { value: 1, text: '330200', label: '宁波' }, { value: 2, text: '330100', label: '杭州' }, { value: 3, text: '330300', label: '温州' }
];
export default class AddReport extends Component {
    constructor(props) {
        super(props);
        if (!window.globalvariable.getStore('cityid')) {
            window.globalvariable.setStore('cityid', global.constants.cityid);
        }
        this.state = {
            hospitallist: [],
            mcid: 0,
            params: { mcno: '', tjbh: '', ckmm: '', mcid: 0 },
            reportlist: [],
            cityid: 0,
            citycode: 0,
            bannerList: [],
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    onCity = (e) => {
        let mc = posts.find((value) => value.value === e[0]);
        this.setState(
            { cityid: e, citycode: mc.text, hospitalid: 0 },
            () => {
                this.GetReportTreelist();
            }
        );

    }
    componentDidMount() {
        let mc = posts.find((value) => value.text === window.globalvariable.getStore('cityid'));
        if (!!mc) {
            let cm = [];
            cm.push(mc.value)
            this.setState(
                { cityid: cm, citycode: mc.text },
                () => {
                    this.GetReportTreelist();
                }
            );
        }
        this.GetReportListP();
        this.GetadvertisementList();
    }
    GetadvertisementList = () => {
        services.GetadvertisementList(global.advertisement.advertisement_wxreport, '').then(data => {
            if (data.status === 0) {
                this.setState({ bannerList: data.result });
            }
        });
    }
    GetReportListP = () => {
        services.GetReportListP('').then(data => {
            if (data.status === 0) {
                this.setState({ reportlist: data.result });
            } else {
                Toast.offline(data.message);
            }
        })
    }
    GetReportTreelist = () => {
        services.GetReportTreelist(this.state.citycode, false).then(hospital => {
            if (hospital.status === 0) {
                let hospitalData = [];
                hospital.result.forEach(element => {
                    hospitalData.push({ value: element.mcid, label: element.mcname, text: element.mcno });
                });
                this.setState({ hospitallist: hospitalData });
            } else {
                Toast.offline(hospital.message);
            }
        })
    }
    onHospital = (e) => {
        let params = this.state.params;
        let mc = this.state.hospitallist.find((value) => value.value === parseInt(e.toString()));
        params.mcno = mc.text;
        this.setState({ mcid: e });
        params.mcid = mc.value;
        this.setState({ params: params });
    }
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let params = this.state.params;
        params[name] = value;
        this.setState({
            params: params
        });
    }
    onChange = (val) => {
        let reportlist = this.state.reportlist;
        reportlist[val].ischeck = reportlist[val].ischeck === true ? false : true;
        this.setState({ reportlist: reportlist });
    }
    add = (val) => {
        let params = this.state.params;
        if (!!params.mcno === false) {
            Toast.offline('请选择您体检的医院', 2);
            return false;
        }
        if (!!params.tjbh === false) {
            Toast.offline('请输入您的报告编号', 2);
            return false;
        }
        if (!!params.ckmm === false) {
            Toast.offline('请输入正确的报告密码', 2);
            return false;
        }
        services.AddReport1(this.state.params, '正在导入，请稍等').then(data => {
            if (data.status === 0) {
                Toast.success(data.message, 2, () => {
                    history.push('/members/report');
                    history.go();
                });
            } else {
                Toast.offline(data.message);
            }
        });
    }
    add2 = (val) => {
        let reportlist = this.state.reportlist;
        let params = [];
        if (!!reportlist === false || reportlist.length === 0) {
            Toast.offline('您暂时还没有可以绑定的报告', 2);
            return false;
        }
        reportlist.forEach(data => {
            if (data.ischeck) {
                let value = {};
                value.tjbh = data.tjbh;
                value.hospitalno = data.hospitalno;
                params.push(value);
            }
        });

        if (!!params === false || params.length === 0) {
            Toast.offline('您还没有选择要绑定的报告', 2);
            return false;
        }
        services.Addmatic(params, '').then(data => {
            if (data.status === 0) {
                Toast.success(data.message, 2, () => {
                    history.push('/members/report');
                    history.go();
                });
            } else {
                Toast.offline(data.message);
            }
        });
    }
      //链接跳转
      openlink =(data,e) =>
      {
          if(!!data)
          {
              if(fun.IsWebsite(data.link) )
              {            
                  window.location.href = fun.IsHttp(data.link);
              }else if(data.link !=='' && data.link !=='/')
              {
                  history.push(data.link);
                  history.go();
              }
          }
      }
    render() {
        const { hospitallist, reportlist } = this.state;
        return <div className="report">
            <CommonlyHeadMembers barname="添加体检报告" />
            <Tabs tabs={tabs2}
                initialPage={0}
                tabBarPosition="top"
                tabBarActiveTextColor={'#32a128'}
                tabBarInactiveTextColor={'#000000'}
                renderTab={tab => <span>{tab.title}</span>}
            >
                <div className="addreportbox" >
                    <List renderHeader={() => '*所有项目必填，请仔细输入'}>
                        <Picker
                            data={posts}
                            value={this.state.cityid}
                            cols={1}
                            onChange={this.onCity}
                            extra="请选择体检城市"
                        ><List.Item arrow="horizontal">体检城市：</List.Item>
                        </Picker>
                        <Picker
                            data={hospitallist}
                            value={this.state.mcid}
                            cols={1}
                            onChange={this.onHospital}
                            extra="请选择体检中心"
                        >
                            <List.Item arrow="horizontal">体检中心：</List.Item>
                        </Picker>
                        <List.Item>
                            <span className="name">体检编号：</span><input type="text" placeholder="由体检中心提供" name="tjbh" onChange={this.handleInputChange} />
                        </List.Item>
                        <List.Item>
                            <span className="name">查询密码：</span><input type="password" name="ckmm" placeholder="请输入体检报告查询密码" onChange={this.handleInputChange} />
                        </List.Item>

                    </List>
                    <Button className="submitBut" onClick={this.add} >导入报告</Button>
                    <WhiteSpace />
                    <div className="advertisementbox">
                        {
                            this.state.bannerList.length > 0 ?
                                this.state.bannerList.map((data, index) => (
                                    <div className="advertisement" key={index} >
                                        <img alt={data.title} src={data.picpath} onClick={this.openlink.bind(this, data)} />
                                    </div>
                                ))
                                : ''
                        }
                    </div>
                </div>
                <div className="addreportbox">
                    <List renderHeader={() => '为您关联所有体检人报告，可以多选导入'}>
                        {reportlist.map((data, index) => (
                            <CheckboxItem key={index} onChange={() => this.onChange(index)}>
                                <div className="dd"><div>{data.name}({data.jcrq})</div><div>{data.xm}</div></div>
                            </CheckboxItem>
                        ))}
                    </List>
                    {
                        reportlist.length > 0 ? <Button className="submitBut" onClick={this.add2.bind(this)} >导入报告</Button> :
                            <div className="errordiv"><img alt='' src={require('../../../res/images/zwsj.png')} />
                                <p>对不起，您暂时没有可以自动匹配的报告</p>
                            </div>
                    }

                    <WhiteSpace />
                </div>

            </Tabs>

        </div >;
    }
}
